var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('p',{staticClass:"tit"},[_vm._v(_vm._s(_vm.$t(_vm.stateMsgForStore[0])))]),_c('ul',{staticClass:"ul"},[_c('li',[_c('span',[_vm._v(_vm._s(_vm.$t(_vm.stateMsgForStore[1])))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }